import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { AddPortCallSummaryTab as SummaryTab, SubmittedPortCall } from './summary';

import { IssueCountPillBadge } from 'portcall/issues/view';
import { PortCallScheduleView } from 'portcall/portcallschedule/view';

export const AddPortCallSummaryTabView = SuperCritical(({ model: m } : { model : SummaryTab }) =>
    <div className="addportcallsummarytab">
        <div className="main">
            <div className="order-header">
                <div className="order-submitted">Your order has been submitted.</div>
                <div className="order-link"><a href={'#!portcallprofile?id=' + m.SelectedSchedule()?.PortCall.Id()}>View PortCall</a></div>
            </div>
            <BatchDetails model={m} />
            <SelectedSchedule model={m} />
        </div>
        <PortCallSelector model={m} />
    </div>
);

const BatchDetails = SuperCritical(({ model: m } : { model : SummaryTab }) =>
    m.Batch() &&
        <div className="batch-details">
            Your batch reference number is {m.Batch()!.Model.ReferenceNumber()}.
        </div>
);

const SelectedSchedule = SuperCritical(({ model: m } : { model : SummaryTab }) =>
    <div className="schedule">
        {m.SelectedSchedule() && <PortCallScheduleView model={m.SelectedSchedule()!} />}
    </div>
);

const PortCallSelector = SuperCritical(({ model: m } : { model : SummaryTab }) =>
    m.PortCalls().length > 1 ?
        <div className="portcall-selector">
            {m.PortCalls().map((pc, i) =>
                <PortCallSelectorOption portcall={pc} index={i} key={pc.Model.Id()} />
            )}
        </div> :
        null
);

const PortCallSelectorOption = SuperCritical(({ portcall: pc, index: i } : { portcall : SubmittedPortCall, index : number }) =>
    <div className="portcall-selector-option">
        <span className="selection-indicator-shell">
            {/* TODO: The designs show a different indicator shape. That'd be a good use for Icomoon. See
                PortCall.FrontEnd/Content/icomoon/Read Me.txt */}
            {pc.IsSelected() && <span className="selection-indicator fa fa-caret-right" />}
        </span>
        <span className="selection-button" onClick={pc.Select}>
            PC #{(i + 1).toLocaleString()}
        </span>
        <IssueCountPillBadge className="issue-badge" issues={pc.Issues} />
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/addportcall/summaryview.tsx